import { useEffect, useState } from 'react';

type UnitRental = {
  id: string;
  start_at: string;
  due_at?: string | null;
  returned_at?: string | null;
  daily_rate: number;
  subtotal: number;
  adjustments: number;
  total: number;
};

export default function RentalHistory({ unitId }: { unitId: string }) {
  const [rows, setRows] = useState<UnitRental[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!unitId) { setLoading(false); return; }
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`/api/asset-instances/${unitId}/rentals`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        setRows(Array.isArray(data) ? data : (data.data || []));
      } finally {
        setLoading(false);
      }
    })();
  }, [unitId]);

  if (!unitId) return <div className="text-muted-foreground">No unit selected.</div>;
  if (loading) return <div>Loading rental history…</div>;

  return (
    <div className="rounded-md border overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-muted/50">
          <tr>
            <th className="text-left font-semibold px-4 py-3">Start</th>
            <th className="text-left font-semibold px-4 py-3">Due</th>
            <th className="text-left font-semibold px-4 py-3">Returned</th>
            <th className="text-left font-semibold px-4 py-3">Daily Rate</th>
            <th className="text-left font-semibold px-4 py-3">Subtotal</th>
            <th className="text-left font-semibold px-4 py-3">Adjustments</th>
            <th className="text-left font-semibold px-4 py-3">Total</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id} className="border-t">
              <td className="px-4 py-3">{new Date(r.start_at).toLocaleString()}</td>
              <td className="px-4 py-3">{r.due_at ? new Date(r.due_at).toLocaleString() : '-'}</td>
              <td className="px-4 py-3">{r.returned_at ? new Date(r.returned_at).toLocaleString() : '-'}</td>
              <td className="px-4 py-3">£{Number(r.daily_rate).toLocaleString()}</td>
              <td className="px-4 py-3">£{Number(r.subtotal).toLocaleString()}</td>
              <td className="px-4 py-3">£{Number(r.adjustments).toLocaleString()}</td>
              <td className="px-4 py-3 font-medium">£{Number(r.total).toLocaleString()}</td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td className="px-4 py-6 text-center text-muted-foreground" colSpan={7}>No rental cycles recorded.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}


